import { createContext, useReducer } from 'react';
export const GlobalContext = createContext();
import globalReducer from './reducer';
import { initGlobal } from './init';
import PropTypes from 'prop-types';
export const GlobalProvider = ({ children }) => {
  const [state, dispatch] = useReducer(globalReducer, initGlobal);
  return <GlobalContext.Provider value={{ state, dispatch }}>{children}</GlobalContext.Provider>;
};

GlobalProvider.propTypes = {
  children: PropTypes.node.isRequired
};
